// extracted by mini-css-extract-plugin
export default {"wrap":"LIWCXR-w","customSplitter":"jx5exYBq","authbtn":"KUwv4JSZ","inlineButton":"-G8GQGjL","composite":"WdZAkczK"};